var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountDeposite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22110",
    "data-name": "Group 22110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.764,
    height: 19.887,
    viewBox: "0 0 21.764 19.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9349",
    "data-name": "Rectangle 9349",
    width: 21.764,
    height: 19.886,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22110-2",
    "data-name": "Group 22110",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16144",
    "data-name": "Path 16144",
    d: "M407.845,255.471c-.006-.077-.03-.157.036-.223v.212l-.016.01Z",
    transform: "translate(-386.118 -241.655)",
    fill: "#9e7352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16145",
    "data-name": "Path 16145",
    d: "M15.436,78.415c.889,0,1.779,0,2.668.009a.74.74,0,0,1,.353.034c-.113.106-.254.072-.384.072q-3.59,0-7.181,0c-.408,0-.408,0-.408.4q0,7.307,0,14.615c0,.4,0,.4.41.4q3.612,0,7.223,0c.13,0,.272-.035.384.073a.486.486,0,0,1-.289.036q-7.3,0-14.6-.006A3.564,3.564,0,0,1,0,90.468q0-4.218,0-8.436a3.537,3.537,0,0,1,2.755-3.5,4.031,4.031,0,0,1,.927-.1c.566-.007,1.133-.009,1.7-.013a.552.552,0,0,1,.263-.069c1.588,0,3.177-.008,4.765,0,1.586-.012,3.172,0,4.758-.005a.61.61,0,0,1,.266.064",
    transform: "translate(0 -74.177)",
    fill: "#d96500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16146",
    "data-name": "Path 16146",
    d: "M203.571,95.942q-1.667,0-3.334,0c-1.5,0-3,0-4.5,0-.185,0-.254-.036-.254-.242q.009-7.539,0-15.079c0-.2.065-.243.252-.243q3.8.009,7.6,0c.064,0,.127,0,.191-.006a2.116,2.116,0,0,1,1.868,1.863c0,.75-.012,1.5,0,2.25,0,.206-.06.251-.238.181a.894.894,0,0,0-.334-.04h-3.058a3.494,3.494,0,0,0-3.179,2.208,3.537,3.537,0,0,0,3.108,4.855c.919.056,1.837.017,2.756.031a2.348,2.348,0,0,0,.751-.087c.169-.054.192,0,.191.149,0,.686,0,1.373,0,2.06,0,.078.005.155.008.233a2.115,2.115,0,0,1-1.825,1.862",
    transform: "translate(-185.07 -76.096)",
    fill: "#ff7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16147",
    "data-name": "Path 16147",
    d: "M106.125,4.241c-.3,0-.608.011-.912.011q-2.059,0-4.118-.008,1.247-1.115,2.495-2.23,1.012-.9,2.028-1.8a.652.652,0,0,1,.675-.179.589.589,0,0,0-.1.4q0,1.73,0,3.46a.476.476,0,0,1-.068.345",
    transform: "translate(-95.711 -0.001)",
    fill: "#9abf2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16148",
    "data-name": "Path 16148",
    d: "M195.55,4.78q0-2,0-3.994c0-.119-.013-.24.168-.212a.451.451,0,0,1,.3.143q2.267,2.012,4.532,4.027a.176.176,0,0,1,.024.034l-5.023,0",
    transform: "translate(-185.136 -0.539)",
    fill: "#87a12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16149",
    "data-name": "Path 16149",
    d: "M256.257,119.583c-.009-.01-.025-.018-.027-.029a2.11,2.11,0,0,0-1.262-1.635c-.108-.05-.117-.114-.117-.21q0-1.017,0-2.034a.609.609,0,0,0-.033-.311c-.091.084-.066.2-.066.3,0,.623,0,1.246,0,1.87,0,.21-.014.219-.221.184a1.994,1.994,0,0,0-.339-.023h-3.039a2.218,2.218,0,0,0-.318.017,3.585,3.585,0,0,0-2.7,5.284,3.46,3.46,0,0,0,2.943,1.881c.849.068,1.7.016,2.548.04a6.979,6.979,0,0,0,.868-.057c.263-.025.263-.033.263.24,0,.6,0,1.2,0,1.806,0,.1-.026.215.068.3a.632.632,0,0,0,.032-.311c0-.664,0-1.327,0-1.991a.246.246,0,0,1,.16-.269,2.067,2.067,0,0,0,1.211-1.6c.038-.07-.014-.155.036-.223ZM251.287,122a.712.712,0,1,1,.714-.72.722.722,0,0,1-.714.72",
    transform: "translate(-234.494 -109.22)",
    fill: "#d96500"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountDeposite);
export default __webpack_public_path__ + "static/media/my-account-deposite.2e5e6cf639b53f8bdefd0d2f7550bfdc.svg";
export { ForwardRef as ReactComponent };